<template>
    <div class="bg-white h-screen overflow-auto print:h-auto print:overflow-visible">
        <div class="relative bg-gray-800 print:hidden">
            <header class="relative z-10">
                <nav aria-label="Top">
                    <HeaderPublic />

                    <HeaderMenuPublic />
                </nav>
            </header>
        </div>

        <main>
            <div>
                <slot />
            </div>
        </main>

        <FooterPublic class="print:hidden" />
    </div>
</template>

<script setup lang="ts">
import FooterPublic from "~/components/layouts/Public/FooterPublic.vue"
import HeaderMenuPublic from "~/components/layouts/Public/HeaderMenuPublic.vue"
import {useAuthStore} from "~/store/auth"

const authStore = useAuthStore()

onMounted(() => {
    if (authStore.isAuthenticated === null) {
        authStore.getAuthData()
    }
})
</script>
